import { render } from "./Purchase_Orders.vue?vue&type=template&id=6aee159d&scoped=true"
import script from "./Purchase_Orders.vue?vue&type=script&lang=js"
export * from "./Purchase_Orders.vue?vue&type=script&lang=js"

import "./Purchase_Orders.vue?vue&type=style&index=0&id=6aee159d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aee159d"]])

export default __exports__